import { useMemo } from 'react'
import ReactECharts from 'echarts-for-react'

const CHANNEL_COLORS: Record<string, string> = {
  'Direct': '#6366F1',
  'Organic Search': '#10B981',
  'Referral': '#F59E0B',
  'Paid Search': '#8B5CF6',
  'Organic Social': '#EC4899',
  'Paid Social': '#14B8A6',
  'Email': '#F97316',
  'Display': '#06B6D4',
  'AI': '#A855F7',
}
const DEFAULT_COLOR = '#94A3B8'

interface ChannelTrendsData {
  dates: string[]
  channels: string[]
  series: { channel: string; data: number[] }[]
}

interface ChannelTrendsChartProps {
  data: ChannelTrendsData
}

export function ChannelTrendsChart({ data }: ChannelTrendsChartProps) {
  const option = useMemo(() => {
    return {
      grid: { left: 56, right: 16, top: 16, bottom: 60 },
      xAxis: {
        type: 'category' as const,
        data: data.dates,
        axisLabel: {
          color: '#8B8FA7',
          fontSize: 11,
        },
        axisLine: { lineStyle: { color: '#E2E4ED' } },
        axisTick: { show: false },
      },
      yAxis: {
        type: 'value' as const,
        axisLabel: {
          color: '#8B8FA7',
          fontSize: 11,
        },
        splitLine: { lineStyle: { color: '#E2E4ED', type: 'dashed' as const } },
      },
      tooltip: {
        trigger: 'axis' as const,
        backgroundColor: '#1B2559',
        borderColor: '#1B2559',
        textStyle: { color: '#fff', fontSize: 12 },
      },
      legend: {
        bottom: 0,
        textStyle: { color: '#8B8FA7', fontSize: 11 },
      },
      series: data.series.map((s) => ({
        name: s.channel,
        type: 'line' as const,
        data: s.data,
        smooth: 0.3,
        symbol: 'none' as const,
        lineStyle: {
          width: 2,
          color: CHANNEL_COLORS[s.channel] ?? DEFAULT_COLOR,
        },
        itemStyle: {
          color: CHANNEL_COLORS[s.channel] ?? DEFAULT_COLOR,
        },
      })),
    }
  }, [data])

  return (
    <div className="bg-white border border-[#E2E4ED] rounded-xl p-5">
      <h3 className="text-sm font-semibold text-[#1B2559] mb-4">
        Tendances des canaux de trafic
      </h3>
      <ReactECharts option={option} style={{ height: 280 }} />
    </div>
  )
}
